var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 209.411,
    height: 70,
    viewBox: "0 0 209.411 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15083",
    "data-name": "Path 15083",
    d: "M192.735,0H16.686c-.642,0-1.276,0-1.916,0-.536,0-1.067.014-1.608.022A23.125,23.125,0,0,0,9.655.335a11.664,11.664,0,0,0-3.327,1.1A11.266,11.266,0,0,0,3.5,3.495,10.952,10.952,0,0,0,1.434,6.332,11.552,11.552,0,0,0,.34,9.663a22.737,22.737,0,0,0-.314,3.5C.01,13.7.009,14.241,0,14.778v40.45c.009.543.01,1.07.027,1.613a22.737,22.737,0,0,0,.314,3.5,11.528,11.528,0,0,0,1.094,3.333A10.864,10.864,0,0,0,3.5,66.5a10.98,10.98,0,0,0,2.833,2.063,11.726,11.726,0,0,0,3.327,1.1,23.547,23.547,0,0,0,3.507.309c.541.012,1.072.019,1.608.019.64,0,1.274,0,1.916,0h176.05c.629,0,1.268,0,1.9,0,.533,0,1.08-.007,1.613-.019a23.238,23.238,0,0,0,3.5-.309,11.908,11.908,0,0,0,3.339-1.1,10.986,10.986,0,0,0,2.83-2.063,11.192,11.192,0,0,0,2.068-2.825,11.557,11.557,0,0,0,1.083-3.333,23.636,23.636,0,0,0,.325-3.5c.007-.544.007-1.07.007-1.613.014-.636.014-1.268.014-1.914V16.688c0-.641,0-1.277-.014-1.911,0-.537,0-1.075-.007-1.612a23.638,23.638,0,0,0-.325-3.5,11.582,11.582,0,0,0-1.083-3.331,11.316,11.316,0,0,0-4.9-4.9,11.843,11.843,0,0,0-3.339-1.1,22.826,22.826,0,0,0-3.5-.309c-.533-.009-1.08-.019-1.613-.022-.629,0-1.268,0-1.9,0Z",
    transform: "translate(0 0)",
    fill: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15084",
    "data-name": "Path 15084",
    d: "M14.124,67.812c-.533,0-1.053-.007-1.583-.019a22.206,22.206,0,0,1-3.271-.285,10.3,10.3,0,0,1-2.9-.959A9.46,9.46,0,0,1,3.926,64.77,9.311,9.311,0,0,1,2.14,62.326a10.013,10.013,0,0,1-.95-2.9A21.723,21.723,0,0,1,.9,56.145c-.011-.369-.026-1.6-.026-1.6V14.121s.015-1.21.026-1.565a21.648,21.648,0,0,1,.29-3.276,10.072,10.072,0,0,1,.951-2.909A9.4,9.4,0,0,1,3.916,3.925,9.739,9.739,0,0,1,6.37,2.135a10.19,10.19,0,0,1,2.893-.952A22.026,22.026,0,0,1,12.545.9L14.125.875H193.969l1.6.022a21.674,21.674,0,0,1,3.252.285,10.392,10.392,0,0,1,2.924.959,9.789,9.789,0,0,1,4.226,4.235,10.085,10.085,0,0,1,.937,2.886,22.743,22.743,0,0,1,.3,3.3c.005.5.005,1.028.005,1.558.014.656.014,1.281.014,1.911V52.657c0,.636,0,1.256-.014,1.882,0,.569,0,1.09-.007,1.627a22.279,22.279,0,0,1-.3,3.244,10.044,10.044,0,0,1-.945,2.922,9.591,9.591,0,0,1-1.777,2.425,9.473,9.473,0,0,1-2.449,1.789,10.258,10.258,0,0,1-2.919.962,21.948,21.948,0,0,1-3.271.285c-.513.012-1.049.019-1.57.019l-1.9,0Z",
    transform: "translate(0.655 0.656)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>",
    transform: "translate(17.45 15.261)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_2",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_3",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_",
    "data-name": "<Path>",
    d: "M35.867,25.046a8.66,8.66,0,0,1,4.124-7.266A8.865,8.865,0,0,0,33.006,14c-2.939-.308-5.788,1.758-7.285,1.758-1.526,0-3.832-1.728-6.315-1.677a9.3,9.3,0,0,0-7.828,4.774c-3.384,5.86-.86,14.472,2.382,19.208,1.622,2.319,3.518,4.91,6,4.818,2.427-.1,3.334-1.548,6.264-1.548,2.9,0,3.753,1.548,6.284,1.489,2.6-.042,4.246-2.33,5.811-4.671a19.183,19.183,0,0,0,2.657-5.412A8.369,8.369,0,0,1,35.867,25.046Z",
    transform: "translate(-9.972 -4.781)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_2",
    "data-name": "<Path>",
    d: "M24.472,14.829a8.527,8.527,0,0,0,1.95-6.109,8.676,8.676,0,0,0-5.613,2.9,8.114,8.114,0,0,0-2,5.882A7.173,7.173,0,0,0,24.472,14.829Z",
    transform: "translate(-3.357 -8.72)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(42.797 16.014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15085",
    "data-name": "Path 15085",
    d: "M48.208,33.936H39.925L37.936,39.81H34.427l7.846-21.731h3.645L53.764,39.81H50.2Zm-7.426-2.71h6.566l-3.237-9.533h-.091Z",
    transform: "translate(-34.427 -17.716)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15086",
    "data-name": "Path 15086",
    d: "M61.556,29.438c0,4.924-2.635,8.087-6.612,8.087a5.371,5.371,0,0,1-4.985-2.772h-.075V42.6H46.631V21.515h3.148V24.15h.06a5.62,5.62,0,0,1,5.045-2.8C58.905,21.349,61.556,24.528,61.556,29.438Zm-3.343,0c0-3.208-1.658-5.317-4.187-5.317-2.485,0-4.156,2.153-4.156,5.317,0,3.192,1.671,5.33,4.156,5.33C56.555,34.768,58.213,32.674,58.213,29.438Z",
    transform: "translate(-25.274 -15.265)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15087",
    "data-name": "Path 15087",
    d: "M71.521,29.438c0,4.924-2.635,8.087-6.612,8.087a5.371,5.371,0,0,1-4.985-2.772h-.075V42.6H56.6V21.515h3.148V24.15h.06a5.62,5.62,0,0,1,5.045-2.8C68.87,21.349,71.521,24.528,71.521,29.438Zm-3.343,0c0-3.208-1.658-5.317-4.187-5.317-2.485,0-4.156,2.153-4.156,5.317,0,3.192,1.671,5.33,4.156,5.33,2.529,0,4.187-2.094,4.187-5.33Z",
    transform: "translate(-17.801 -15.265)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15088",
    "data-name": "Path 15088",
    d: "M73.137,33.91c.241,2.155,2.334,3.57,5.2,3.57,2.741,0,4.713-1.415,4.713-3.358,0-1.687-1.189-2.7-4.006-3.389l-2.816-.678c-3.99-.964-5.843-2.83-5.843-5.858,0-3.75,3.268-6.325,7.907-6.325,4.592,0,7.74,2.575,7.846,6.325H82.851c-.2-2.169-1.989-3.478-4.609-3.478s-4.413,1.324-4.413,3.252c0,1.536,1.145,2.44,3.946,3.132l2.394.588c4.459,1.054,6.311,2.845,6.311,6.024,0,4.066-3.239,6.612-8.389,6.612-4.819,0-8.073-2.487-8.283-6.417Z",
    transform: "translate(-7.892 -17.871)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15089",
    "data-name": "Path 15089",
    d: "M85.734,19.3v3.75h3.013v2.575H85.734v8.735c0,1.357.6,1.989,1.928,1.989a10.161,10.161,0,0,0,1.07-.075v2.56a8.931,8.931,0,0,1-1.806.15c-3.208,0-4.459-1.2-4.459-4.278V25.625h-2.3V23.049h2.3V19.3Z",
    transform: "translate(-0.126 -16.799)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15090",
    "data-name": "Path 15090",
    d: "M86.065,29.449c0-4.985,2.936-8.118,7.514-8.118,4.594,0,7.516,3.132,7.516,8.118s-2.907,8.118-7.516,8.118S86.065,34.447,86.065,29.449Zm11.717,0c0-3.42-1.567-5.438-4.2-5.438s-4.2,2.034-4.2,5.438c0,3.433,1.565,5.436,4.2,5.436s4.2-2,4.2-5.436Z",
    transform: "translate(4.301 -15.276)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15091",
    "data-name": "Path 15091",
    d: "M96.186,21.515h3.1v2.7h.075a3.779,3.779,0,0,1,3.811-2.863,5.016,5.016,0,0,1,1.114.121v3.042a4.546,4.546,0,0,0-1.461-.2,3.277,3.277,0,0,0-3.389,3.645v9.4H96.186Z",
    transform: "translate(11.891 -15.265)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15092",
    "data-name": "Path 15092",
    d: "M115.509,32.716c-.437,2.876-3.239,4.85-6.822,4.85-4.609,0-7.47-3.088-7.47-8.042,0-4.97,2.876-8.193,7.333-8.193,4.384,0,7.14,3.011,7.14,7.815V30.26H104.5v.2a4.126,4.126,0,0,0,4.262,4.488,3.585,3.585,0,0,0,3.659-2.229Zm-10.994-4.729h7.921a3.81,3.81,0,0,0-3.886-4.021,4.011,4.011,0,0,0-4.035,4.021Z",
    transform: "translate(15.665 -15.276)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "_Group_4",
    "data-name": "<Group>",
    transform: "translate(62.424 14.765)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15093",
    "data-name": "Path 15093",
    d: "M39.443,8.736a4.619,4.619,0,0,1,4.913,5.188c0,3.336-1.8,5.253-4.913,5.253H35.671V8.736ZM37.293,17.7h1.969a3.283,3.283,0,0,0,3.444-3.755,3.292,3.292,0,0,0-3.444-3.734H37.293Z",
    transform: "translate(-35.671 -8.222)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15094",
    "data-name": "Path 15094",
    d: "M41.688,14.2a3.733,3.733,0,1,1,7.432,0,3.734,3.734,0,1,1-7.432,0Zm5.833,0c0-1.708-.767-2.707-2.114-2.707s-2.112,1-2.112,2.707.76,2.713,2.112,2.713,2.114-1,2.114-2.713Z",
    transform: "translate(-31.171 -7.184)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15095",
    "data-name": "Path 15095",
    d: "M55.326,18.075H53.713l-1.629-5.8h-.123l-1.622,5.8h-1.6l-2.172-7.88h1.577l1.412,6.013h.116l1.62-6.013h1.492l1.62,6.013h.123l1.4-6.013H57.49Z",
    transform: "translate(-27.497 -7.119)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15096",
    "data-name": "Path 15096",
    d: "M53.854,10.263h1.5v1.252h.116a2.359,2.359,0,0,1,2.352-1.4,2.563,2.563,0,0,1,2.728,2.931v5.1H58.991V13.433c0-1.266-.55-1.9-1.7-1.9a1.808,1.808,0,0,0-1.882,2v4.61H53.854Z",
    transform: "translate(-22.034 -7.187)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15097",
    "data-name": "Path 15097",
    d: "M59.094,8.437h1.555V19.393H59.094Z",
    transform: "translate(-18.104 -8.437)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15098",
    "data-name": "Path 15098",
    d: "M61.225,14.2a3.734,3.734,0,1,1,7.433,0,3.734,3.734,0,1,1-7.433,0Zm5.833,0c0-1.708-.767-2.707-2.114-2.707s-2.112,1-2.112,2.707.76,2.713,2.112,2.713,2.114-1,2.114-2.713Z",
    transform: "translate(-16.518 -7.184)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15099",
    "data-name": "Path 15099",
    d: "M66.4,15.912c0-1.418,1.056-2.236,2.931-2.352l2.135-.123v-.68c0-.832-.55-1.3-1.613-1.3-.868,0-1.47.319-1.642.876H66.705c.159-1.354,1.432-2.222,3.22-2.222,1.976,0,3.09.983,3.09,2.648V18.14h-1.5V17.033h-.123a2.651,2.651,0,0,1-2.367,1.237A2.38,2.38,0,0,1,66.4,15.912Zm5.065-.673v-.659l-1.924.123c-1.085.073-1.577.442-1.577,1.136s.615,1.122,1.461,1.122a1.858,1.858,0,0,0,2.04-1.723Z",
    transform: "translate(-12.624 -7.184)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15100",
    "data-name": "Path 15100",
    d: "M71.348,15.45c0-2.49,1.28-4.067,3.271-4.067a2.6,2.6,0,0,1,2.416,1.382h.116V8.437h1.555V19.393h-1.49V18.148h-.123a2.735,2.735,0,0,1-2.475,1.375C72.615,19.523,71.348,17.946,71.348,15.45Zm1.606,0c0,1.671.788,2.677,2.105,2.677s2.121-1.02,2.121-2.67-.819-2.677-2.121-2.677-2.106,1.013-2.106,2.67Z",
    transform: "translate(-8.913 -8.437)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15101",
    "data-name": "Path 15101",
    d: "M79.238,14.2a3.733,3.733,0,1,1,7.432,0,3.734,3.734,0,1,1-7.432,0Zm5.833,0c0-1.708-.767-2.707-2.114-2.707s-2.112,1-2.112,2.707.76,2.713,2.112,2.713S85.07,15.912,85.07,14.2Z",
    transform: "translate(-3.009 -7.184)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15102",
    "data-name": "Path 15102",
    d: "M84.669,10.263h1.5v1.252h.116a2.359,2.359,0,0,1,2.352-1.4,2.563,2.563,0,0,1,2.728,2.931v5.1H89.807V13.433c0-1.266-.55-1.9-1.7-1.9a1.808,1.808,0,0,0-1.882,2v4.61H84.669Z",
    transform: "translate(1.078 -7.187)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15103",
    "data-name": "Path 15103",
    d: "M94.719,9.074v2h1.707v1.31H94.719v4.052c0,.825.34,1.187,1.114,1.187a5.191,5.191,0,0,0,.593-.036v1.3a5.1,5.1,0,0,1-.846.079c-1.729,0-2.418-.608-2.418-2.128v-4.45H91.911v-1.31h1.251v-2Z",
    transform: "translate(6.509 -7.959)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15104",
    "data-name": "Path 15104",
    d: "M95.7,8.437h1.541V12.78h.123a2.425,2.425,0,0,1,2.4-1.412,2.6,2.6,0,0,1,2.714,2.938v5.088h-1.557v-4.7c0-1.259-.586-1.9-1.685-1.9a1.841,1.841,0,0,0-1.984,2v4.6H95.7Z",
    transform: "translate(9.354 -8.437)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15105",
    "data-name": "Path 15105",
    d: "M107.8,16.012a3.2,3.2,0,0,1-3.415,2.28,3.579,3.579,0,0,1-3.64-4.067,3.634,3.634,0,0,1,3.633-4.117c2.193,0,3.515,1.5,3.515,3.972v.543h-5.564v.087a2.083,2.083,0,0,0,2.1,2.257,1.889,1.889,0,0,0,1.875-.955Zm-5.47-2.54h3.98a1.9,1.9,0,0,0-1.94-2.041,2.015,2.015,0,0,0-2.04,2.041Z",
    transform: "translate(13.109 -7.184)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadBlack);
export default __webpack_public_path__ + "static/media/download-black.f8ecc0106f0f102d0f7a6a7501b39a4e.svg";
export { ForwardRef as ReactComponent };